import { Achievements } from "@highmarch/app";
import { almanacModel, almanacNote } from "../ui/hub/almanacModel";
import { showAlmanac } from "../ui/hub/almanacSheet";
import type { Feature } from "./registry";

/** More-sheet slot: after Achievements (30), before the Guide (80) (registry.ts MORE_ORDER). */
export const ALMANAC_ORDER = 40;

/**
 * The Almanac (FINISH_PLAN WP7, M20): More → Almanac — raiders, bosses, towers with their mastery trims, elite affixes
 * and Mythic powers, from the lifetime stats (the achievements feature records them) and the shared "weak to" table.
 * A reference, never a nudge: no red count.
 */
export const almanacFeature: Feature = {
  id: "almanac",
  register(ctx, registry) {
    const a = new Achievements(ctx.catalog);
    registry.moreRow({
      id: "almanac", order: ALMANAC_ORDER, icon: "almanac",
      label: () => "Almanac",
      note: () => almanacNote(almanacModel(ctx.catalog, a)),
      open: (hub) => { showAlmanac(hub.parent, { catalog: ctx.catalog, achievements: a }); },
    });
  },
};
